/**
 * Decodes a JWT payload. Returns null for malformed tokens instead of throwing.
 */
export const decodeToken = (token: string) => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
};

/**
 * Returns true when the string is a JWT that can be decoded and is not past exp.
 * Malformed tokens and expired tokens are unusable. Tokens without exp are treated as usable.
 */
export function isUsableCustomerToken(
  token: string | null | undefined,
  nowSeconds: number = Math.floor(Date.now() / 1000)
): boolean {
  if (!token) return false;
  const decoded = decodeToken(token);
  if (!decoded) return false;
  if (typeof decoded.exp === "number" && decoded.exp < nowSeconds) {
    return false;
  }
  return true;
}
